// extracted by mini-css-extract-plugin
export default {"font-list":"FontList_font-list__jDRvU","loading-wrapper":"FontList_loading-wrapper__ZM3z-"};